import { Routes } from '@angular/router';

import { ContentLayout } from './layouts/content-layout/content-layout';
import { Home } from './shared/components/home/home';
import { AuthGuard } from './modules/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: ContentLayout,
    children: [
      {
        path: '',
        component: Home,
        pathMatch: 'full',
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
  },
  { path: '**', redirectTo: '/login' }
];
